import { render } from "./SetPassword.vue?vue&type=template&id=5a22b84c&scoped=true&ts=true"
import script from "./SetPassword.vue?vue&type=script&lang=ts"
export * from "./SetPassword.vue?vue&type=script&lang=ts"

import "./SetPassword.vue?vue&type=style&index=0&id=5a22b84c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a22b84c"]])

export default __exports__